export default {"src":"/_next/static/media/disqus.543f125a.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};